import { RequestConfig } from '~/common/services/requests';
import { AnyDocument } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructGet } from '../../../types/ConstructGet';
import { PaginatedResponse } from '../../../types/PaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const getApplicationQueryResults = async (
  constructGet: ConstructGet,
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
  statusDefinition?: string,
): Promise<PaginatedResponse<AnyDocument[]> | undefined> =>
  constructGet(`${APPLICATION_BASE_PATH}/${uuid}/queries`, {
    params,
    headers: {
      [InceptHeader.DefinitionName]: definitionName,
      ...(statusDefinition
        ? { [InceptHeader.StatusName]: statusDefinition }
        : {}),
    },
  });
